import { omit } from 'lodash'
import type { TFunction } from 'i18next'

export interface MenuDataItem {
  authority?: string[] | string
  children?: MenuDataItem[]
  hideChildrenInMenu?: boolean
  hideInMenu?: boolean
  icon?: React.ReactNode
  locale?: string
  name?: string
  key?: string
  path?: string
  [key: string]: any
  parentKeys?: string[]
}

/**
 * 将地址转成 ant layout 的配置，并返回有权限的菜单
 * @param routes 路由配置
 */
export function antRoutes(routes: MenuDataItem[] = [], t: TFunction): MenuDataItem[] {
  if (!Array.isArray(routes)) {
    return []
  }

  // 没权限的菜单没有menuTitle，会被过滤掉
  const validRoutes = routes.filter((route) => route.menuTitle)
  if (validRoutes.length === 0) {
    return []
  }

  return validRoutes.map((route) => {
    const antRoute = {
      ...omit(route, ['routes']),
      name: t(route.menuTitle),
      path: route.path,
    }

    if (Array.isArray(route.routes) && route.routes.length > 0) {
      return {
        ...antRoute,
        children: antRoutes(route.routes, t),
      }
    }

    return antRoute
  })
}
